import { createBrowserRouter, RouterProvider } from 'react-router';
import { routes } from '@/routes/router';
import { AppProviders } from './providers';

const router = createBrowserRouter(routes);

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
